import {
  Activity,
  BookOpen,
  Boxes,
  Cable,
  ClipboardCheck,
  Cpu,
  Download,
  FileText,
  Gauge,
  Gift,
  GitCompare,
  GraduationCap,
  HardHat,
  Library,
  Lightbulb,
  ListChecks,
  PenTool,
  Plug,
  Presentation,
  Search,
  ShieldCheck,
  Star,
  Users,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Electrical Fundamentals', icon: BookOpen },
  { label: 'Lab Safety, PPE & LOTO', icon: HardHat },
  { label: 'Circuit Theory & Ohm’s Law', icon: Zap },
  { label: 'Residential Wiring', icon: Plug },
  { label: 'Circuit Protection', icon: ShieldCheck },
  { label: 'Motors & Controls', icon: Gauge },
  { label: 'Commercial & Industrial Systems', icon: Cable },
  { label: 'Electrical Diagrams', icon: FileText },
  { label: 'Testing & Troubleshooting', icon: Search },
  { label: 'PLCs, VFDs & Automation', icon: Cpu },
  { label: 'Course Programs', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Competency Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: PenTool },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Smart Electrical Systems', icon: Lightbulb },
  { label: 'Immediate Digital Access', icon: Download },
]
